const styles = (theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  divider: { width: 1, height: 20, margin: 10 },
  textField: { minWidth: 130 }
});

export default styles;
